import { Fragment, useContext } from "react";
import { Link, Outlet } from "react-router-dom";
import darkMode from "../../assets/darkmode.svg";
import lightMode from "../../assets/lightmode.svg";
import { ModeContext } from "../../context/mode.context";

import "./navigation.router.scss";
const Navigation = () => {
  const { mode, setMode } = useContext(ModeContext);
  const ModeHandler = () => setMode(!mode);

  return (
    <Fragment>
      <header className={`navigation ${mode ? ` navigation-dark` : ``}`}>
        <Link
          className={`navigation__header ${
            mode ? ` navigation-dark__header` : ``
          }`}
          to="/"
        >
          Where in the world?
        </Link>

        <h3
          className={`navigation__mode ${mode ? ` navigation-dark__mode` : ``}`}
          onClick={ModeHandler}
        >
          <img
            src={!mode ? darkMode : lightMode}
            alt="LightMode SVG"
            className="navigation__mode--img"
          />
          <p
            className={`navigation__mode--text ${
              mode ? ` navigation-dark__mode--text` : ``
            }`}
          >
            {!mode ? `Dark Mode` : `Light Mode`}
          </p>
        </h3>
      </header>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;
